
import axiosClient from './axiosClient';


export const organizationInviteAPI = {

    inviteMembersToOrganization: async (paylaodDetails:{email:string, role_id:string}): Promise<any> => {
      const response = await axiosClient.post<any>(`/organization-invitations`,{
        email:paylaodDetails.email,
        role_id:paylaodDetails.role_id
      });
      return response.data;
    },

    validateInvite: async (paylaodDetails:{email:string, token:string}): Promise<any> => {
        const response = await axiosClient.post<any>(`/organization-invitations/validate`,{
          email:paylaodDetails.email,
          token:paylaodDetails.token
        });
        const d = response.data;
        return {
          ...d,
          invitation_id: d?.invitation_id ?? d?.invitationId,
        };
      },

      sendOtp: async (paylaodDetails:{email:string, invitationId:string}): Promise<any> => {
        const response = await axiosClient.post<any>(`/organization-invitations/send-otp`,{
          email:paylaodDetails.email,
          invitation_id:paylaodDetails.invitationId
        });
        return response.data;
      },
      verfiyOtp: async (paylaodDetails:{email:string, invitationId:string, otp:string}): Promise<any> => {
        const response = await axiosClient.post<any>(`/organization-invitations/verify-otp`,{
          email:paylaodDetails.email,
          otp:paylaodDetails.otp,
          invitation_id:paylaodDetails.invitationId
        });
        const d = response.data;
        return {
          ...d,
          temp_token: d?.temp_token ?? d?.tempToken,
        };
      },

      setPassword: async (paylaodDetails:{firstName:string, lastName:string, userName:string, token:string, password:String}): Promise<any> => {
        const response = await axiosClient.post<any>(`/organization-invitations/set-password`,{
            temp_token:paylaodDetails.token,
            first_name:paylaodDetails.firstName,
            last_name:paylaodDetails.lastName,
            username:paylaodDetails.userName,
            password:paylaodDetails.password
        });
        return response.data;
      },


  };